import React from "react";
import { useFormikContext } from "formik";
import { FormControlLabel, Switch, Typography, Box } from "@material-ui/core";
import { fontConfig } from "theme/fontConfig";

const SwitchField = ({
  name,
  title,
  labelPlacement = "start",
  mandatory,
  ...rest
}) => {
  const { values, setFieldValue } = useFormikContext();

  const handleChange = (event) => {
    const { checked } = event.target;
    setFieldValue(name, checked);
  };

  return (
    <Box display="flex" alignItems="center" mb={2}>
      <FormControlLabel
        control={
          <Switch
            color="primary"
            checked={!!values[name]}
            onChange={handleChange}
            inputProps={{ "aria-label": name }}
            {...rest}
          />
        }
        label={
          <Typography
            style={{
              fontSize: 12,
              fontFamily: fontConfig.FormManageToggleTextFont.family,
              fontWeight: 500,
              color: "#3F4254",
            }}
          >
            {title}
            {mandatory && (
              <span style={{ color: "red", fontSize: 15 }}> *</span>
            )}
          </Typography>
        }
        labelPlacement={labelPlacement}
        style={{
          marginLeft: labelPlacement === "start" && 0,
        }}
      />
    </Box>
  );
};

export default SwitchField;
